<template>
  <div class="container-fluid">
    <Loader :loader="loaderActive"/>
    <div class="row">
      <div class="back-link">
        <router-link to="/profile"> ←</router-link>
      </div>
    </div>
    <div class="row">
      <div class="page-title d-flex justify-content-center align-items-center">{{ $t('EDIT_PROFILE') }}</div>
      <div class="profile-image d-flex flex-column justify-content-center align-items-center">
        <div class="avatar-upload">
          <div class="avatar-edit">
            <input ref="fileInput"
                   type='file'
                   id="imageUpload"
                   accept=".png, .jpg, .jpeg"
                   @input="pickFile"/>
            <label for="imageUpload"></label>
          </div>
          <div class="avatar-preview" >
            <div id="imagePreview" :style="{ 'background-image': `url(${image})` }">
            </div>
          </div>
        </div>
        <div class="user-name mb-4" style="color:#3EAAFF;">{{ userName }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 mx-auto">
        <label>Full Name</label>
        <argon-input type="text"
                     placeholder="Name"
                     v-on:change="(event) => userName = event.target.value"
                     :value="userName"
                     aria-label="পুরোনাম"
                     :isRequired="true"/>
        <span class="text-danger" v-if="userNameErr">{{ userNameErr }}</span>
        <label>Mobile</label>
        <argon-input type="text"
                     placeholder="Phone"
                     v-on:change="(event) => userPhone = event.target.value"
                     :value="userPhone"
                     aria-label="Phone"
                     :isDisabled="true"/>
        <label>Email</label>
        <argon-input type="text"
                     placeholder="ইমেইল"
                     v-on:change="(event) => userEmail = event.target.value"
                     :value="userEmail"
                     aria-label="Email"
                     :isRequired="true"/>
        <span class="text-danger" v-if="userEmailErr">{{ userEmailErr }}</span>

        <div class="d-flex justify-content-between align-items-center">
          <argon-button fullWidth color="danger" variant="gradient" class="my-4 mb-2 me-2" @click="cancelUpdate" style="background:#8435E8 ">
            {{ $t('CANCEL') }}</argon-button>
          <argon-button fullWidth color="dark" variant="gradient" class="my-4 mb-2" @click="updateProfile" style="background:#3EAAFF ">{{ $t('SAVE') }}</argon-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/views/components/Loader";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton";
import {sendRequest} from "@/http/axios.method";

export default {
  name: "EditProfile",
  components: {
    Loader,
    ArgonInput,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token,
        'content-type': 'multipart/form-data',
      },
      image: this.$route.query.image,
      userName: this.$route.query.name,
      userEmail: this.$route.query.email,
      userPhone: this.$route.query.phone,
      fileInput: '',
      userNameErr: '',
      userEmailErr: '',
      userAvatar: '',
    }
  },
  methods: {
    selectImage() {
      this.$refs.fileInput.click()
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.image = e.target.result
        }
        reader.readAsDataURL(file[0]);
        this.$emit('input', file[0]);
        this.userAvatar = file[0];
        this.updateAvatar();
      }
    },

    updateAvatar() {
      let formData = new FormData();
      formData.append('image', this.userAvatar);
      this.loaderActive = true;
      sendRequest('post', 'v2.0/user/update-avatar', formData, this.config)
          .then(() => {
            this.loaderActive = false;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    cancelUpdate() {
      this.$router.push('/profile');
    },
    updateProfile() {
      this.userNameErr = '';
      this.userEmailErr = '';
      if (this.userName.length === 0) {
        this.userNameErr = 'Please provide your full name.';
        return;
      }
      if (this.userEmail.length === 0) {
        this.userEmailErr = 'Please provide your email.';
        return;
      }
      let data = {
        name: this.userName,
        email: this.userEmail,
      }
      sendRequest('post', 'v2.0/user', data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.$router.push('/profile');
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  }
}
</script>

<style scoped>
</style>
